<template>
  <div class="copytos">
    <van-cell-group title="抄送人" :border="true" size="large">
      <div class="approvers">
          <van-row type="flex" justify="center" class="approver">
            <van-col span="6" v-for="copyto in flow.copytos" :key="copyto.id">
              <van-image
                round
                width="3rem"
                height="3rem"
                :src="copyto.thumb_avatar"
              />
              <h3>{{copyto.name}}</h3>
              <p>{{copyto.position}}</p>
            </van-col>

          </van-row>
          
        <van-divider />
        </div>
        <!--添加抄送人 -->
        <div>
          <van-row type="flex" justify="center" class="add_button" v-if="flow.role==2||flow.role==1">
            <van-col span="8">
              <van-button icon="plus" type="primary" @click="user.show=true" round native-type="button">添加抄送人</van-button>
            </van-col>
          </van-row>

        </div>
      
      
   
    </van-cell-group>
    
    <!-- <van-popup  position="bottom" v-model="user.show" :style="{ height: '100%' }"> -->
    <mu-dialog transition="slide-bottom" fullscreen lock-scroll scrollable :open.sync="user.show">
      <mu-paper :z-depth="1" class="demo-list-wrap">
        <div class="user_top">
          <mu-appbar color="indigo500">
            通讯录
            <mu-button icon slot="right">
              <!-- <mu-icon :value="close"></mu-icon> -->
              <van-icon name="close" @click="user.show = false" />
            </mu-button>
          </mu-appbar>
          
          <van-search placeholder="请输入用户姓名" v-model="userForm.user" @input="getUser()"/>
        </div>
        <div class="user_content">
          <mu-list v-for="(items,key) in user.data" :key="key">
            <mu-sub-header>{{key}}</mu-sub-header>
            <mu-list-item avatar button :ripple="false" v-for="item in items" :key="item.userid" @click="addCopyto(item)">
              <mu-list-item-action>
                <mu-avatar>
                  <img :src="item.thumb_avatar">
                </mu-avatar>
              </mu-list-item-action>
              <mu-list-item-title>{{item.name}}</mu-list-item-title>
              <mu-list-item-sub-title>{{item.position}}</mu-list-item-sub-title>
              <!-- <mu-list-item-action>
                <mu-icon :value="item.position"></mu-icon>
              </mu-list-item-action> -->
            </mu-list-item>
            <mu-divider></mu-divider>
          </mu-list>
        </div>
      </mu-paper>
    </mu-dialog>
    <!-- </van-popup> -->
  </div>
</template>

<script>
export default {
  name: 'CopyTo',
  props: {
    flow:Object,
    users:Object,
  },
  data(){
    return{
      user:{
        show:false,
        data:this.users,
      },
      userForm:{
        user:'',
      },
      addCopytoForm:{

      },
    }
  },
  created(){
    // this.getUser();
  },
  methods:{
    getUser(){
      this.$http.post('get_users',this.userForm)
      .then((res)=>{
        this.user.data = res.data.data
      })
    },
    addCopyto(user){
      // console.log(user)
      
      this.addCopytoForm.user = user
      this.addCopytoForm.flow_id = this.flow.id
      this.$confirm(
        '确定添加抄送人：'+user.name+'?','提示'
      )
      .then(({ result })=>{
        if(!result){
          return false;
        }
        this.user.show = false;
        this.userForm.user ='';
        this.$http.post('flow/add_copyto',this.addCopytoForm)
        .then((res)=>{
          console.log(res)
          if(res.data.code !=200){
            this.$dialog.alert({
              message: res.data.msg,
            })
            return false;
          }
          this.$dialog.alert({
            message: res.data.msg,
          })
          .then((res)=>{
            location.reload()
          })
        })
      })

    },
  },
  watch:{
    users:function(val){
      this.user.data = val
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.approvers{
  text-align: 0 auto;
  /* margin:10px; */
  /* margin-bottom:100px; */
}
.approver{
  /* float:left; */
  padding:10px;

}

.approver .van-step{
  display:block;

}
h3 {
  font-size:12px;
  margin:5px;
}
p{
  margin:0px;
  font-size:12px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  /* display: inline-block; */
  margin: 0 10px;
}
a {
  color: #42b983;
}
.van-cell-group__title{
  background-color:#3f51b5 ;
  font-size:14px;
  font-weight:blod;
  color:white;
  padding:13px;

}
.copytos{
  margin-bottom:100px;
  padding-bottom:15px;

}


.user_top{
  position:fixed;
  top:0px;
  width:100%;
  z-index:2;
}
.user_content{
  margin-top:110px;
}


  
</style>
<style>
/* .mu-dialog-wrapper, .mu-dialog, .mu-dialog-body{
  max-height:none !important;
} */
.mu-dialog-fullscreen .mu-dialog-body {
    padding: 0;
    max-height: 1200px !important;
}
  
</style>
